// Iter-275 — Multi-vertical Savings Opportunity Score promo strip.
//
// Drives visitors from the homepage to /savings-opportunity-score. This
// is CarSavr's competitive differentiator (no competitor ships a multi-
// vertical savings tool) and the literal expression of the brand
// promise ("save money on car ownership in 2 minutes").

import { Link } from "react-router-dom";
import { Sparkles, ShieldCheck, RefreshCw, Wrench, ArrowRight } from "lucide-react";

const PILLARS = [
  { Icon: ShieldCheck, label: "Insurance" },
  { Icon: RefreshCw, label: "Refinance" },
  { Icon: Wrench, label: "Warranty" },
];

export default function SavingsScorePromo() {
  return (
    <section
      className="bg-[#0A2540] text-white"
      data-testid="home-savings-score-promo"
      aria-label="2-minute savings check"
    >
      <div className="max-w-wide mx-auto px-6 lg:px-10 py-10 sm:py-14 lg:pt-8 lg:pb-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10 items-center">
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-[#10B981] mb-3">
              <Sparkles className="w-3.5 h-3.5" /> New · 2-minute savings check
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight mb-4">
              See where you could be <span className="text-[#10B981]">saving money.</span>
            </h2>
            <p className="text-base sm:text-lg text-slate-200 max-w-2xl mb-6">
              Check insurance, refinancing, and vehicle protection in one quick experience. See your potential savings in dollars per year — no email required.
            </p>
            <div className="flex flex-wrap gap-4 items-center">
              <Link
                to="/savings-opportunity-score"
                data-testid="home-savings-score-cta"
                className="inline-flex items-center justify-center gap-2 h-12 px-6 bg-[#10B981] hover:bg-[#34D399] text-slate-950 font-semibold transition-colors"
              >
                See My Savings <ArrowRight className="w-4 h-4" />
              </Link>
              <span className="text-xs text-slate-500">Free · No email required · 100% in your browser</span>
            </div>
          </div>
          <div className="lg:col-span-5">
            <div className="grid grid-cols-3 gap-3 sm:gap-4">
              {PILLARS.map(({ Icon, label }) => (
                <div
                  key={label}
                  className="border border-slate-700 bg-slate-900/40 p-4 sm:p-5 text-center"
                  data-testid={`home-savings-score-pillar-${label.toLowerCase()}`}
                >
                  <Icon className="w-6 h-6 text-[#10B981] mx-auto mb-2" />
                  <div className="text-xs sm:text-sm font-semibold">{label}</div>
                </div>
              ))}
            </div>
            <div className="mt-4 text-xs text-slate-500 text-center">
              Three ways to save. One simple check.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
